import { render, staticRenderFns } from "./PreOrdersTable.vue?vue&type=template&id=447f9343"
import script from "./PreOrdersTable.vue?vue&type=script&lang=js"
export * from "./PreOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports